import { Component, OnInit, HostListener, Input } from '@angular/core';
import get from 'lodash-es/get';

import { IPicture } from '@finder/shared/components/picture/picture.interface';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';

export interface GAVData {
    id: string;
    name: string;
    img?: string;
    lid: string;
    // eslint-disable-next-line id-blacklist
    number?: number;
    themePark: string;
    thumbnailUrl?: string;
    thumbnailSquareUrl?: string;
    url: string;
    picture?: IPicture;
    onClick?: any;
    onSeen?: any;
}

@Component({
    selector: 'finder-guests-also-viewed',
    templateUrl: './guests-also-viewed.component.html',
    styleUrls: ['./guests-also-viewed.component.scss'],
})
export class GuestsAlsoViewedComponent implements OnInit {

    @Input() public gavTitle: string;

    public gavData: GAVData[];
    public gav: any;

    constructor(
        public windowRef: WindowRef
    ) { }

    @HostListener('window:gavChanged', ['$event'])
    onGAVChanged(event) {
        this.gavData = event.detail;

        // We just want to wait a tick to trigger a scroll so that the animation happens properly
        setTimeout(() => {
            this.windowRef.nativeWindow.dispatchEvent(new Event('scroll'));
        });
    }

    ngOnInit() {
        this.gavTitle = get(this.gavTitle, 'title');
    }
}

(() => {
    if (window) {
        // Expose the function globally so it is accessible to T&T
        (window as any).recommend = (input) => {
            // We can work with T&T data to get the images just right, but this makes things a little simpler
            // for us to have control over the image size we want/need
            const adjustImageSize = (img, width, height) => {
                const dimensions = /\/mwimage\/1\/(\d+)\/(\d+)\//i;
                const matches = img.match(dimensions);

                if (matches) {
                    img = img.replace(matches[1], width);
                    img = img.replace(matches[2], height);
                }

                return img;
            };

            // This is lifted directly from the mbox code. It is part of the way that the rendering happens
            // in the "old" ways. Not sure if we need this or not, but for now I am leaving it in place.
            const clipAttractionName = (attractionName) =>
                attractionName.length < 56 ?
                    attractionName :
                    attractionName.substring(0, 53).trim() + '&hellip;';

            const detail = input.filter(item => {
                // GIT-8836 - Ensure we have proper data to bind
                if (!item.name || !item.themePark || !item.thumbnailUrl) {
                    return;
                }

                return item;
            }).map(item => {
                item.picture = {
                    desktop: adjustImageSize(item.thumbnailUrl, 410, 205),
                    mobile: adjustImageSize(item.thumbnailUrl, 335, 167),
                    media: '(max-width: 768px)',
                    alt: item.themePark
                };
                item.themePark = clipAttractionName(item.themePark);

                return item;
            });

            window.dispatchEvent(
                new CustomEvent('gavChanged', {
                    detail,
                    bubbles: true
                })
            );
        };
    }
})();
